// Libraries
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// Models
import { IPrivateRouteProps } from './models/PrivateRoute';

export const PrivateRoute: React.FC<IPrivateRouteProps> = ({ redirect, isAuthenticated }) => {
    return isAuthenticated ? <Outlet /> : <Navigate to={redirect} />;
};
